import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { heroContent, images } from '../../data/mock';

const Hero = () => {
  const titleRef = useRef(null);
  const bgRef = useRef(null);

  useEffect(() => {
    // Animate title
    gsap.fromTo(
      titleRef.current,
      { opacity: 0, y: 60 },
      { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out', delay: 0.3 }
    );

    // Animate background
    gsap.fromTo(
      bgRef.current,
      { scale: 1.1 },
      { scale: 1, duration: 1.5, ease: 'power2.out' }
    );
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          ref={bgRef}
          src={images.heroBg}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1121] via-[#0B1121]/80 to-[#0B1121]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1121] via-transparent to-[#0B1121]/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 l-container py-40">
        <h1
          ref={titleRef}
          className="font-serif text-[clamp(2.5rem,6vw,5rem)] leading-[1.1] text-white max-w-4xl"
        >
          {heroContent.title}
          <br />
          <span className="text-[#4ECDC4]">{heroContent.highlight}</span>
          <br />
          {heroContent.titleEnd}
        </h1>
      </div>
    </section>
  );
};

export default Hero;
